module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ded#ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notes#notes"
    }
  }, [_vm._v("Notes of Gratitude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraph#epi"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/authornote#anote"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/map#map"
    }
  }, [_vm._v("Map")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#pro"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("One: Born to Die")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two: Mom’s the Word")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three: Dressing up Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four: The Good, the Bad, and the Ugly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five: Sex Lives and Videotape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six: Cruise Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven: Fever")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight: The Fame Game")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine: First Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten: Casualty of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleven: Right Place, Wrong Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twelve: Miami Vice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen: King of the Catwalk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fourteen: Men on a Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifteen: Bewitched")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sixteen: Countdown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seventeen: America’s Most Wanted")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eighteen: Fear on the Streets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineteen: Celebrity Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty: Comedy of Errors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-one: The Drag Artist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-two: Blank Check")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-three: Appointment with Destiny")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-four: No Turning Back")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epigraph1#taph",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epitaph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St. Martin’s Paperbacks titles by Wensley Clarkson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0